import { render, staticRenderFns } from "./wzzj2.vue?vue&type=template&id=beb4e9b6&scoped=true&"
import script from "./wzzj2.vue?vue&type=script&lang=js&"
export * from "./wzzj2.vue?vue&type=script&lang=js&"
import style0 from "./wzzj2.vue?vue&type=style&index=0&id=beb4e9b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb4e9b6",
  null
  
)

export default component.exports